module.exports = __webpack_public_path__ + "static/media/applestore.f7483cbb.png";